<template>
<div>

  <!-- Page Preview -->
  <el-dialog :title="pages.preview.page" :visible.sync="pages.preview.visible">
    <div style="height: 500px; overflow-x: auto">
      <div v-html="pages.preview.html"></div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="pages.preview.visible=false">Close</el-button>
      <el-button type="info" @click="publishPage(pages.preview.page);pages.preview.visible=false">Publish</el-button>
    </div>
  </el-dialog>

  <!-- Timeline Preview -->
  <el-dialog title="Timeline" :visible.sync="timelineVisible">
    <div style="height: 500px; overflow-x: auto">
      <iframe :src="`https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=${timelineId}&font=Default&lang=en&initial_zoom=2&width=${timeline.width}&height=${timeline.height}`" :width="timeline.width" :height="timeline.height" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder='0'></iframe>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="timelineVisible=false">Close</el-button>
      <el-button type="info" @click="updateTimeline();timelineVisible=false">Publish</el-button>
    </div>
  </el-dialog>

  <!-- Main panel -->
  <div style="font-size:13px;font-family: Geneva, arial, helvetica, sans-serif;border:1px solid #BBBBBB;width:800px;overflow:scroll;position:absolute;top:160px;bottom:0px">
    <div style="margin-top:20px;padding:0px;margin-left:10px">

      <!-- Layout -->
      <folder>
        <b>Layout</b>
        <div slot="items">
          <el-radio-group :value="$store.state.frontConfig.layout.align">
            <el-radio @change="updateLayout('left')" label="left">Left</el-radio>
            <el-radio @change="updateLayout('center')" label="center">Center</el-radio>
            <el-radio @change="updateLayout('right')" label="right">Right</el-radio>
          </el-radio-group>
        </div>
      </folder>

      <!-- Carousel -->
      <folder>
        <b>Carousel</b>
        <div slot="items">
          <div style="margin: 10px auto; width: 700px">
            <el-button @click="updateCarousel" type="info" size="small" round>Publish</el-button>
            <el-input type="textarea" rows="10" v-model="carouselContent"></el-input>
          </div>
        </div>
      </folder>

      <!-- Timeline -->
      <folder>
        <b>Timeline</b>
        <div slot="items">
          <div style="margin: 10px auto; width: 700px">
            <div style="margin-bottom:5px">
              <el-button @click="updateTimeline" type="info" size="small" round>Publish</el-button>
              <el-button @click="previewTimeline" type="info" size="small" plain round>Preview</el-button>
            </div>
            <table>
              <tr><td>Src</td>    <td><el-input v-model="timeline.src"></el-input></td>    <td width="50px"><a :href="timeline.src" target="_blank">Goto</a></td></tr>
              <tr><td>Height</td> <td><el-input v-model="timeline.height"></el-input></td> <td></td></tr>
              <tr><td>Width</td>  <td><el-input v-model="timeline.width"></el-input></td>  <td></td></tr>
            </table>
          </div>
        </div>
      </folder>

      <!-- Home, Research, Tools -->
      <div v-for="(page,ipage) in ['home', 'research', 'tools']" :key="ipage">
        <folder>
        <b>{{page}}</b>
          <div slot="items">
            <div style="padding-left:20px">
              <div style="margin: 10px 0px">
                <el-button @click="publishPage(page)" type="info" size="mini" round>Publish</el-button>
                <el-button @click="pages.preview.html=pages[page].html;pages.preview.page=page;pages.preview.visible=true" type="info" size="mini" plain round>Preview</el-button>
                <el-button @click="pages[page].syncPreview.visible=!pages[page].syncPreview.visible" type="info" size="mini" plain round>Sync Preview</el-button>
                <el-button @click="formatCodes(page)" type="info" size="mini" plain round>Format Codes</el-button>
              </div>

              <div style="margin:10px">
                <!--
                <codemirror ref="myCm" :value="$store.state.frontConfig[page].src" :options="pages.srcOptions" @ready="pages[page].html=$store.state.frontConfig[page].src" @input="updateHtml($event, page)">
                -->
                <codemirror ref="myCm" v-model="pages[page].html" :options="pages.srcOptions" @ready="pages[page].html=$store.state.frontConfig[page].src">
                </codemirror>
              </div>

              <div v-if="pages[page].syncPreview.visible">
                <h3>Preview</h3>
                <div style="height:300px;overflow-x:auto">
                  <div v-html="pages[page].html"></div>
                </div>
              </div>
            </div>
          </div>
        </folder>
      </div>

    </div>
  </div>
</div>
</template>

<script>

import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/theme/base16-dark.css'
import 'codemirror/keymap/sublime.js'

import beautify from 'js-beautify'

export default {
  name: 'Members',

  components: {
    codemirror
  },

  data () {
    return {
      pages: {
        preview: {
          visible: false,
          html: '',
          page: 'home'
        },

        srcOptions: {
          tabSize: 4,
          mode: 'text/javascript',
          theme: 'base16-dark',
          lineNumbers: true,
          line: true,
          keyMap: 'sublime'
        },

        home: {
          html: '',
          syncPreview: {
            visible: false
          }
        },

        research: {
          html: '',
          syncPreview: {
            visible: false
          }
        },

        tools: {
          html: '',
          syncPreview: {
            visible: false
          }
        }
      },

      context: {
        style: {
          width: '100px',
          position: 'absolute',
          left: '0px',
          top: '0px',
          zIndex: '99',
          display: 'none',
          backgroundColor: 'white',
          boxShadow: '0 24px 38px 3px rgba(0,0,0,0.14),0 9px 46px 8px rgba(0,0,0,0.12),0 11px 15px -7px rgba(0,0,0,0.2)',
          borderRadius: '2px'
        }
      },

      actions: {
        update: {
          tableName: '',
          record: {},
          dialogVisible: false
        },
        insert: {
          tableName: '',
          record: {},
          dialogVisible: false
        },
        erase: {
          tableName: '',
          record: {},
          dialogVisible: false
        }
      },

      config: this.$store.state.frontConfig,

      carouselContent: JSON.stringify(this.$store.state.frontConfig.carousel),

      timeline: this.$store.state.frontConfig.timeline,
      timelineVisible: false
    }
  },

  computed: {
    timelineId () {
      var found = this.timeline.src.match(/https:\/\/docs.google.com\/spreadsheets\/d\/([^/]+)\/edit#/)
      if (found) {
        return found[1]
      } else {
        return ''
      }
    },

    storedPages () {
      return {
        home: this.$store.state.frontConfig.home.src,
        research: this.$store.state.frontConfig.research.src,
        tools: this.$store.state.frontConfig.tools.src
      }
    },

    frontConfig () {
      return this.$store.state.frontConfig
    }
  },

  watch: {
    storedPages (val) {
      this.pages.home.html = val.home
      this.pages.research.html = val.research
      this.pages.tools.html = val.tools
    },

    frontConfig (val) {
      this.config = val
      this.carouselContent = JSON.stringify(this.config.carousel)
    }
  },

  methods: {
    updateCarousel () {
      var conf = this.frontConfig
      conf.carousel = JSON.parse(this.carouselContent)
      this.$store.commit('updateFrontConfig', conf)
    },

    previewTimeline () {
      this.timelineVisible = true
    },

    updateTimeline () {
      var conf = this.frontConfig
      conf.timeline = this.timeline
      this.$store.commit('updateFrontConfig', conf)
      alert('Update Successfully')
    },

    formatCodes (page) {
      var v = this
      v.pages[page].html = beautify.html(v.pages[page].html, { indent_size: 2, space_in_empty_paren: true, wrap_attributes: 'auto', wrap_line_length: 80 })
    },

    updateHtml (e, page) {
      this.pages[page].html = e
    },

    publishPage (page) {
      var v = this
      var conf = v.frontConfig
      conf[page].src = v.pages[page].html
      v.$store.commit('updateFrontConfig', conf)
    },

    updateLayout (l) {
      var v = this
      var conf = v.frontConfig
      conf.layout.align = l
      v.$store.commit('updateFrontConfig', conf)
    },

    documentClick (e) {
      if (e.which === 1) {
        this.context.style.display = 'none'
      }
    }
  },

  mounted () {
  },

  created () {
    document.addEventListener('click', this.documentClick)
  },

  destroyed () {
    // important to clean up!!
    document.removeEventListener('click', this.documentClick)
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

$theme-color: #666666;

.theme-color {
  color: $theme-color;
}

.introduction {
  padding: 10px 30px;
  color: #5a5e66;
  font-size: 14px;
  text-align: justify;
}

img {
  width: 50%;
}

.mem {
  cursor: pointer;
  font-size: 12px;
}

.mems {
  font-size: 12px;
}

.mem-panel {
  background-color:#EEEEEE;
  border:1px solid #BBBBBB;
  padding:5px 10px;
  text-align: justify;
  text-justify: inter-word;
}

.button {
  cursor: pointer;
}

table.table-strip tr:nth-child(even) {
  background-color: #f2f2f2
}

.tree-leaf {
  cursor: pointer;
}

.tree-leaf:hover {
  text-decoration: underline;
}

.context-menu-item {
  padding: 5px;
  font-size: 11px;
  cursor: pointer;
  font-weight: normal;
}

.context-menu-item:hover {
  background-color: $theme-color;
  color: white;
  font-weight: bold;
}

.input-confirm {
  cursor: pointer;
  font-weight: normal;
}

.input-confirm:hover {
  font-weight: bold;
}

</style>
